/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminDocumentTemplateCategoryControllerCreateDocument } from '../fn/document-template-category/admin-document-template-category-controller-create-document';
import { AdminDocumentTemplateCategoryControllerCreateDocument$Params } from '../fn/document-template-category/admin-document-template-category-controller-create-document';
import { adminDocumentTemplateCategoryControllerDeleteDocument } from '../fn/document-template-category/admin-document-template-category-controller-delete-document';
import { AdminDocumentTemplateCategoryControllerDeleteDocument$Params } from '../fn/document-template-category/admin-document-template-category-controller-delete-document';
import { adminDocumentTemplateCategoryControllerFindAll } from '../fn/document-template-category/admin-document-template-category-controller-find-all';
import { AdminDocumentTemplateCategoryControllerFindAll$Params } from '../fn/document-template-category/admin-document-template-category-controller-find-all';
import { adminDocumentTemplateCategoryControllerUpdateDocument } from '../fn/document-template-category/admin-document-template-category-controller-update-document';
import { AdminDocumentTemplateCategoryControllerUpdateDocument$Params } from '../fn/document-template-category/admin-document-template-category-controller-update-document';
import { adminDocumentTemplateCategoryControllerUpdateOrder } from '../fn/document-template-category/admin-document-template-category-controller-update-order';
import { AdminDocumentTemplateCategoryControllerUpdateOrder$Params } from '../fn/document-template-category/admin-document-template-category-controller-update-order';
import { documentTemplateCategoryControllerCreateDocument } from '../fn/document-template-category/document-template-category-controller-create-document';
import { DocumentTemplateCategoryControllerCreateDocument$Params } from '../fn/document-template-category/document-template-category-controller-create-document';
import { documentTemplateCategoryControllerDeleteDocument } from '../fn/document-template-category/document-template-category-controller-delete-document';
import { DocumentTemplateCategoryControllerDeleteDocument$Params } from '../fn/document-template-category/document-template-category-controller-delete-document';
import { documentTemplateCategoryControllerFindAll } from '../fn/document-template-category/document-template-category-controller-find-all';
import { DocumentTemplateCategoryControllerFindAll$Params } from '../fn/document-template-category/document-template-category-controller-find-all';
import { documentTemplateCategoryControllerUpdateDocument } from '../fn/document-template-category/document-template-category-controller-update-document';
import { DocumentTemplateCategoryControllerUpdateDocument$Params } from '../fn/document-template-category/document-template-category-controller-update-document';
import { documentTemplateCategoryControllerUpdateOrder } from '../fn/document-template-category/document-template-category-controller-update-order';
import { DocumentTemplateCategoryControllerUpdateOrder$Params } from '../fn/document-template-category/document-template-category-controller-update-order';
import { DocumentTemplateCategoryDto } from '../models/document-template-category-dto';

@Injectable({ providedIn: 'root' })
export class DocumentTemplateCategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentTemplateCategoryControllerFindAll()` */
  static readonly DocumentTemplateCategoryControllerFindAllPath = '/api/document-template-category';

  /**
   * 치료 문서 카테고리 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateCategoryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateCategoryControllerFindAll$Response(params?: DocumentTemplateCategoryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentTemplateCategoryDto>>> {
    return documentTemplateCategoryControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 카테고리 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateCategoryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateCategoryControllerFindAll(params?: DocumentTemplateCategoryControllerFindAll$Params, context?: HttpContext): Observable<Array<DocumentTemplateCategoryDto>> {
    return this.documentTemplateCategoryControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentTemplateCategoryDto>>): Array<DocumentTemplateCategoryDto> => r.body)
    );
  }

  /** Path part for operation `documentTemplateCategoryControllerCreateDocument()` */
  static readonly DocumentTemplateCategoryControllerCreateDocumentPath = '/api/document-template-category';

  /**
   * 새 치료 문서 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateCategoryControllerCreateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateCategoryControllerCreateDocument$Response(params: DocumentTemplateCategoryControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateCategoryDto>> {
    return documentTemplateCategoryControllerCreateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 치료 문서 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateCategoryControllerCreateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateCategoryControllerCreateDocument(params: DocumentTemplateCategoryControllerCreateDocument$Params, context?: HttpContext): Observable<DocumentTemplateCategoryDto> {
    return this.documentTemplateCategoryControllerCreateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateCategoryDto>): DocumentTemplateCategoryDto => r.body)
    );
  }

  /** Path part for operation `documentTemplateCategoryControllerUpdateOrder()` */
  static readonly DocumentTemplateCategoryControllerUpdateOrderPath = '/api/document-template-category/order';

  /**
   * 순서 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateCategoryControllerUpdateOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateCategoryControllerUpdateOrder$Response(params: DocumentTemplateCategoryControllerUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return documentTemplateCategoryControllerUpdateOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * 순서 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateCategoryControllerUpdateOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateCategoryControllerUpdateOrder(params: DocumentTemplateCategoryControllerUpdateOrder$Params, context?: HttpContext): Observable<boolean> {
    return this.documentTemplateCategoryControllerUpdateOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `documentTemplateCategoryControllerDeleteDocument()` */
  static readonly DocumentTemplateCategoryControllerDeleteDocumentPath = '/api/document-template-category/{id}';

  /**
   * 치료 문서 삭제
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateCategoryControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateCategoryControllerDeleteDocument$Response(params: DocumentTemplateCategoryControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateCategoryDto>> {
    return documentTemplateCategoryControllerDeleteDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 삭제
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateCategoryControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentTemplateCategoryControllerDeleteDocument(params: DocumentTemplateCategoryControllerDeleteDocument$Params, context?: HttpContext): Observable<DocumentTemplateCategoryDto> {
    return this.documentTemplateCategoryControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateCategoryDto>): DocumentTemplateCategoryDto => r.body)
    );
  }

  /** Path part for operation `documentTemplateCategoryControllerUpdateDocument()` */
  static readonly DocumentTemplateCategoryControllerUpdateDocumentPath = '/api/document-template-category/{id}';

  /**
   * 치료 문서 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentTemplateCategoryControllerUpdateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateCategoryControllerUpdateDocument$Response(params: DocumentTemplateCategoryControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateCategoryDto>> {
    return documentTemplateCategoryControllerUpdateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentTemplateCategoryControllerUpdateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentTemplateCategoryControllerUpdateDocument(params: DocumentTemplateCategoryControllerUpdateDocument$Params, context?: HttpContext): Observable<DocumentTemplateCategoryDto> {
    return this.documentTemplateCategoryControllerUpdateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateCategoryDto>): DocumentTemplateCategoryDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateCategoryControllerFindAll()` */
  static readonly AdminDocumentTemplateCategoryControllerFindAllPath = '/api/document-template-category-admin';

  /**
   * 치료 문서 카테고리 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateCategoryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateCategoryControllerFindAll$Response(params?: AdminDocumentTemplateCategoryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentTemplateCategoryDto>>> {
    return adminDocumentTemplateCategoryControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 카테고리 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateCategoryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateCategoryControllerFindAll(params?: AdminDocumentTemplateCategoryControllerFindAll$Params, context?: HttpContext): Observable<Array<DocumentTemplateCategoryDto>> {
    return this.adminDocumentTemplateCategoryControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentTemplateCategoryDto>>): Array<DocumentTemplateCategoryDto> => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateCategoryControllerCreateDocument()` */
  static readonly AdminDocumentTemplateCategoryControllerCreateDocumentPath = '/api/document-template-category-admin';

  /**
   * 새 치료 문서 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateCategoryControllerCreateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateCategoryControllerCreateDocument$Response(params: AdminDocumentTemplateCategoryControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateCategoryDto>> {
    return adminDocumentTemplateCategoryControllerCreateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 치료 문서 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateCategoryControllerCreateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateCategoryControllerCreateDocument(params: AdminDocumentTemplateCategoryControllerCreateDocument$Params, context?: HttpContext): Observable<DocumentTemplateCategoryDto> {
    return this.adminDocumentTemplateCategoryControllerCreateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateCategoryDto>): DocumentTemplateCategoryDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateCategoryControllerUpdateOrder()` */
  static readonly AdminDocumentTemplateCategoryControllerUpdateOrderPath = '/api/document-template-category-admin/order';

  /**
   * 순서 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateCategoryControllerUpdateOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateCategoryControllerUpdateOrder$Response(params: AdminDocumentTemplateCategoryControllerUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminDocumentTemplateCategoryControllerUpdateOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * 순서 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateCategoryControllerUpdateOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateCategoryControllerUpdateOrder(params: AdminDocumentTemplateCategoryControllerUpdateOrder$Params, context?: HttpContext): Observable<boolean> {
    return this.adminDocumentTemplateCategoryControllerUpdateOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateCategoryControllerDeleteDocument()` */
  static readonly AdminDocumentTemplateCategoryControllerDeleteDocumentPath = '/api/document-template-category-admin/{id}';

  /**
   * 치료 문서 삭제
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateCategoryControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateCategoryControllerDeleteDocument$Response(params: AdminDocumentTemplateCategoryControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateCategoryDto>> {
    return adminDocumentTemplateCategoryControllerDeleteDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 삭제
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateCategoryControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentTemplateCategoryControllerDeleteDocument(params: AdminDocumentTemplateCategoryControllerDeleteDocument$Params, context?: HttpContext): Observable<DocumentTemplateCategoryDto> {
    return this.adminDocumentTemplateCategoryControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateCategoryDto>): DocumentTemplateCategoryDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentTemplateCategoryControllerUpdateDocument()` */
  static readonly AdminDocumentTemplateCategoryControllerUpdateDocumentPath = '/api/document-template-category-admin/{id}';

  /**
   * 치료 문서 수정
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentTemplateCategoryControllerUpdateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateCategoryControllerUpdateDocument$Response(params: AdminDocumentTemplateCategoryControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateCategoryDto>> {
    return adminDocumentTemplateCategoryControllerUpdateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료 문서 수정
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentTemplateCategoryControllerUpdateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDocumentTemplateCategoryControllerUpdateDocument(params: AdminDocumentTemplateCategoryControllerUpdateDocument$Params, context?: HttpContext): Observable<DocumentTemplateCategoryDto> {
    return this.adminDocumentTemplateCategoryControllerUpdateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentTemplateCategoryDto>): DocumentTemplateCategoryDto => r.body)
    );
  }

}
